import {
  CLASS_ACTIVE, CLASS_HIDDEN, CLASS_NEXT,
  CLASS_PREV, CLASS_DISABLED, CLASS_VISIBLE
} from "../../tools/constants/classes";
import { cartAdd } from "@process-creative/slate-theme-tools";

const SEL_PRODUCT_THUMBNAIL = '[data-product-thumbnail]';
const SEL_PRODUCT_SWATCH = '[data-color-id]';
const SEL_PRODUCT_IMAGE = '[data-swatch-image]';
const SEL_PRODUCT_LIFESTYLE_IMAGE = '[data-lifestyle-image]';
const SEL_PRODUCT_CAROUSEL = '[data-product-thumbnail-carousel]';
const SEL_PRODUCT_SAMPLE_ADD = '[data-sample-add]';
const SEL_PRODUCT_SAMPLE_ADD_TEXT = '[data-sample-add-text]';
const SEL_PRODUCT_SAMPLE_LINK = '[data-sample-product-link]';

const SEL_PRODUCT_CAROUSEL_PREV = '[data-thumbnail-carousel-previous]';
const SEL_PRODUCT_CAROUSEL_NEXT = '[data-thumbnail-carousel-next]';
const SEL_PRODUCT_LINKS = '[data-product-link]';
const SEL_CUSTOMISE_LINKS = '[data-customise-link]';

const ATTR_SAMPLE_ID = 'data-sample-variant-id';


const ACTIVE_THUMBNAILS:ProductThumbnail[] = [];

class ProductThumbnail {
  public container:HTMLElement;
  private colorSwatches:NodeListOf<HTMLElement> | null = null;
  private productImage:NodeListOf<HTMLElement> | null = null;
  private sampleAddBtn: HTMLElement | null = null;
  private sampleAddBtnText: HTMLElement|null = null;
  private productLifestyleImage:NodeListOf<HTMLElement> | null = null;
  private productCarousel:any;
  private prev:HTMLElement|null = null;
  private next:HTMLElement|null = null;
  private sampleLink:NodeListOf<HTMLElement> | null = null;
  private productLinks: NodeListOf<HTMLElement> | null = null;
  private customiseLinks: NodeListOf<HTMLAnchorElement> | null = null;

  constructor(container: HTMLElement) {
    this.container = container;
    this.queryChildren(container);
    this.attachEvents();
  }

  queryChildren(container: HTMLElement): void {
    this.colorSwatches = container.querySelectorAll(SEL_PRODUCT_SWATCH);
    this.sampleAddBtn = container.querySelector(SEL_PRODUCT_SAMPLE_ADD);
    this.sampleAddBtnText = container.querySelector(SEL_PRODUCT_SAMPLE_ADD_TEXT);

    this.productImage = container.querySelectorAll(SEL_PRODUCT_IMAGE);
    this.productLifestyleImage = container.querySelectorAll(SEL_PRODUCT_LIFESTYLE_IMAGE);
    this.productCarousel = container.querySelector(SEL_PRODUCT_CAROUSEL);
    this.sampleLink = container.querySelectorAll(SEL_PRODUCT_SAMPLE_LINK);
    this.productLinks = container.querySelectorAll(SEL_PRODUCT_LINKS);
    this.customiseLinks = container.querySelectorAll(SEL_CUSTOMISE_LINKS);

    this.prev = container.querySelector(SEL_PRODUCT_CAROUSEL_PREV);
    this.next = container.querySelector(SEL_PRODUCT_CAROUSEL_NEXT);
  }

  attachEvents() {
    if (ACTIVE_THUMBNAILS.indexOf(this) === -1) ACTIVE_THUMBNAILS.push(this);
    
    if (this.colorSwatches) {
      this.colorSwatches.forEach(link => {
        link.addEventListener('click', (e)=> {
          this.initColors(e);
        })
      })
    }

    if (this.sampleAddBtn) this.sampleAddBtn.addEventListener('click', (e) => this.onAddSampleClick(e));

    if (this.sampleLink) {
      this.sampleLink.forEach(link => {
        link.addEventListener('click', (e)=> {
          this.onSampleLinkClick(e);
        })
      })
    }

    if (this.prev) this.prev.addEventListener('click', (e) => this.onArrowClickNext(e, 'prev'));
    if (this.next) this.next.addEventListener('click', (e) => this.onArrowClickNext(e, 'next'));
  }

  public onArrowClickNext(e: Event, status: String) {
    e.preventDefault();

    if(status == 'prev') {
      this.productCarousel?.classList.add(CLASS_PREV);
      this.productCarousel?.classList.remove(CLASS_NEXT);
    }
    else {
      this.productCarousel?.classList.remove(CLASS_PREV);
      this.productCarousel?.classList.add(CLASS_NEXT);
    }
   
    this.prev?.classList.toggle(CLASS_HIDDEN);
    this.next?.classList.toggle(CLASS_HIDDEN);
  }

  public onSampleLinkClick(e: Event) {
    e.preventDefault();
    e.stopImmediatePropagation();

    this.addItemToCart(this.sampleAddBtn);
  }

  public onAddSampleClick(e: Event) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const addBtn = e.currentTarget as HTMLElement;
    this.addItemToCart(addBtn);
  }

  async addItemToCart(addBtn:any) {
    const variantID = addBtn?.getAttribute(ATTR_SAMPLE_ID);
    let orginalText = this.sampleAddBtnText?.innerText;
    
    if (!variantID || addBtn.hasAttribute('disabled')) return;

    if (this.sampleAddBtnText) {
      addBtn.setAttribute('disabled', 'disabled');
      this.sampleAddBtnText.innerText = 'Adding...'
    }

    try {
      await cartAdd({
        items: [{
          id: parseInt(variantID),
          quantity: 1
        }]
      });

      setTimeout(() => {
        if (this.sampleAddBtnText && orginalText) {
          this.sampleAddBtnText.innerText = 'Added'
        }
      }, 500);
      
      setTimeout(() => {
        if (this.sampleAddBtnText && orginalText) {
          addBtn.removeAttribute('disabled');
          this.sampleAddBtnText.innerText = orginalText
        }
      }, 1500);
    } catch (e) {
      console.error('Failed to add to cart.');
      return;
    }
  }

  public initColors(e: Event) {
    if (!this.productImage || !this.productLifestyleImage) return;

    let colorElement = e.currentTarget as HTMLElement;
    let colorID = colorElement.dataset.colorId;
    let variantID = colorElement.dataset.sampleVariantId;
    let variantLink = colorElement.dataset.variantLink;
    let sampleProductAvailable = colorElement.dataset.sampleAvailable;
    let lifestyleImageCount = 0;

    this.productCarousel?.classList.remove(CLASS_NEXT);
    this.next?.classList.remove(CLASS_DISABLED);
    this.prev?.classList.remove(CLASS_DISABLED);

    this.colorSwatches?.forEach(color => {
      let thisId = color.dataset.colorId;
      thisId == colorID ? color.classList.add(CLASS_ACTIVE) : color.classList.remove(CLASS_ACTIVE);
    });

    this.productLifestyleImage.forEach(lifestyleImage => {
      let lifestyleImagId = lifestyleImage.dataset.lifestyleImage;
      if (!lifestyleImagId) return;

      if (lifestyleImagId == colorID) {
        lifestyleImage.classList.add(CLASS_ACTIVE);
        lifestyleImageCount++;
      } else {
        lifestyleImage.classList.remove(CLASS_ACTIVE);
      }
    });

    this.productImage.forEach(image => {
      let imageId = image.dataset.swatchImage

      if (!imageId) return;
      imageId == colorID ? image.classList.add(CLASS_ACTIVE) : image.classList.remove(CLASS_ACTIVE);
    });

    if (lifestyleImageCount < 1) {
      this.productCarousel?.classList.add(CLASS_NEXT);
      this.next?.classList.add(CLASS_DISABLED);
      this.prev?.classList.add(CLASS_DISABLED);
    } else {
      this.prev?.classList.add(CLASS_HIDDEN);
      this.next?.classList.remove(CLASS_HIDDEN);
    }

    if (variantID && variantLink) {
      this.sampleAddBtn?.setAttribute(ATTR_SAMPLE_ID, variantID);
      this.sampleAddBtn?.toggleAttribute('disabled', colorElement.hasAttribute('disabled'))
      // set disabled text on button

      this.productLinks?.forEach(link => {
        link.setAttribute('href', variantLink)
      });

      if (sampleProductAvailable == "true") {
        this.sampleAddBtn?.removeAttribute('disabled');
      } else {
        this.sampleAddBtn?.setAttribute('disabled', 'disabled');
      }
    }


    // Update Customise Link with Variant URL
    if (variantLink) {
      this.customiseLinks?.forEach(link => {
        let customiserType = 'single_customiser'
        if (link.href.includes('double')) customiserType = 'double_customiser';
        let newHref = `${variantLink}&${customiserType}`
        link.setAttribute('href', newHref);
      });
    }
   }

  detatchEvents() {
    const i = ACTIVE_THUMBNAILS.indexOf(this);
    if (i !== -1) ACTIVE_THUMBNAILS.splice(i, 1);

    if (this.colorSwatches) {
      this.colorSwatches.forEach(link => {
        link.removeEventListener('click', (e)=> {
          this.initColors(e);
        })
      })
    }
    
    if (this.sampleAddBtn) this.sampleAddBtn.removeEventListener('click', (e) => this.onAddSampleClick(e));

    if (this.sampleLink) {
      this.sampleLink.forEach(link => {
        link.removeEventListener('click', (e)=> {
          this.onSampleLinkClick(e);
        })
      })
    }

    if (this.prev) this.prev.removeEventListener('click', (e) => this.onArrowClickNext(e, 'prev'));
    if (this.next) this.next.removeEventListener('click', (e) => this.onArrowClickNext(e, 'next'));
  }
}

export const initialiseProductThumbnails = () => {

  [...ACTIVE_THUMBNAILS].forEach(thumbnail => {
    if (thumbnail.container) return;
    thumbnail.detatchEvents();
  });

  document.querySelectorAll<HTMLElement>(SEL_PRODUCT_THUMBNAIL).forEach(thumb => {
    new ProductThumbnail(thumb);
  });
}

initialiseProductThumbnails();